import { FormGroup, FormLabel, Grid } from '@mui/material';
import SettingsKey from 'app/profile/settings/utils/settingsTypes';
import CustomMenuItem from 'common/components/CustomMenuItem';
import CustomSelectValidator from 'common/components/CustomSelectValidators';
import { useSettingValue } from 'common/hooks/useSettingValue';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getLanguage } from 'redux/slices/settingSlice';

const AppointmentFormSettingsStatus = (props) => {
    const { fields, handleFieldChange, disabled } = props;
    const { t } = useTranslation();

    const statusSetting = useSettingValue(SettingsKey.APPOINTMENT_STATUS) || null;

    const status = useMemo(() => {
        const defaultStatuses = {
            pending: {
                label: { en: 'Pending' },
                children: [],
            },
            done: {
                label: { en: 'Done' },
                children: [],
            },
            cancelled: {
                label: { en: 'Cancelled' },
                children: [],
            },
        };

        if (!statusSetting) {
            return defaultStatuses;
        }

        const result = {};
        // Don't allow any status different from the default
        for (const key of Object.keys(defaultStatuses)) {
            result[key] = statusSetting[key] ?? defaultStatuses[key];
        }

        return result;
    }, [statusSetting]);

    const lang = useSelector(getLanguage);
    const [subStatus, setSubStatus] = useState({});

    useEffect(() => {
        if (statusSetting) {
            setSubStatus(statusSetting?.[fields.status]?.children || {});
        }
    }, [fields.status, statusSetting]);

    useEffect(() => {
        setSubStatus(status?.[fields.status]?.children || {});
    }, [fields.status, status]);

    const changeStatus = (e) => {
        handleFieldChange(e);
        handleFieldChange({
            target: {
                name: 'subStatus',
                value: ' ',
            },
        });
    };

    return (
        <Grid container justifyContent="space-between">
            <Grid item md={4}>
                <FormGroup>
                    <FormLabel>{t('iCalendar.appointmentForm.selectStatus')}</FormLabel>

                    <CustomSelectValidator
                        name="status"
                        select
                        size="small"
                        fullWidth={true}
                        value={fields.status || ' '}
                        onChange={changeStatus}
                        validators={['required']}
                        errorMessages={[t('app.common.required')]}
                        variant="outlined"
                        disabled={disabled}
                    >
                        <CustomMenuItem value=" " disabled>
                            <em>{t('status.select.statusDefault')}</em>
                        </CustomMenuItem>
                        {status &&
                            Object.keys(status).map((key) => (
                                <CustomMenuItem key={key} value={key} noBorder={true}>
                                    {status[key].label?.[lang] || status[key].label?.['en'] || key.toUpperCase()}
                                </CustomMenuItem>
                            ))}
                    </CustomSelectValidator>
                </FormGroup>
            </Grid>
            <Grid item md={7}>
                <FormGroup>
                    <FormLabel>{t('iCalendar.appointmentForm.selectSubStatus')}</FormLabel>

                    <CustomSelectValidator
                        name="subStatus"
                        select
                        size="small"
                        fullWidth={true}
                        value={fields.subStatus || ' '}
                        onChange={handleFieldChange}
                        disabled={!fields?.status}
                        validators={['required']}
                        errorMessages={[t('app.common.required')]}
                        variant="outlined"
                    >
                        <CustomMenuItem value=" " disabled>
                            <em>{t('status.select.subStatusDefault')}</em>
                        </CustomMenuItem>
                        {Object.keys(subStatus).map((key) => (
                            <CustomMenuItem key={key} value={key} noBorder={true}>
                                {subStatus[key]?.label?.[lang] || subStatus[key].label?.['en'] || key.toUpperCase()}
                            </CustomMenuItem>
                        ))}
                    </CustomSelectValidator>
                </FormGroup>
            </Grid>
        </Grid>
    );
};

export default AppointmentFormSettingsStatus;
